import { Component, OnChanges, inject, ChangeDetectionStrategy, input } from '@angular/core';
import {UnitRatingResponse} from '../../../model/unit-rating-response';
import {GuruEntity} from '../../../model/guru-entity';
import {SelectionUtils} from '../../selection-utils';
import {UnitConversionUtils} from '../../unit-conversion-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { HeatingOnlyPerformanceResultsComponent } from '../heating-only-performance-results/heating-only-performance-results.component';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-cabinet-unit-heater-performance-results',
    templateUrl: './cabinet-unit-heater-performance-results.component.html',
    styleUrls: ['./cabinet-unit-heater-performance-results.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, HeatingOnlyPerformanceResultsComponent]
})
export class CabinetUnitHeaterPerformanceResultsComponent implements OnChanges {
  private userStateService = inject(UserStateService);


  readonly ratingResponse = input.required<UnitRatingResponse>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  airflow = 0;
  outputPower = 0;
  fullLoadAmps = 0;
  isExpanded = true;
  isMetric = false;
  private sectionKey = ConfigurationSection.PERFORMANCE_RESULTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.clearOutputValues();
    const metricInput = SelectionUtils.getEntity(this.selectionEntities(), 'USMetricInput');
    this.isMetric = metricInput && 'true' === metricInput.Value;
    if (this.ratingResponse()) {
      this.airflow = this.ratingResponse().Airflow;
      if (this.ratingResponse().CircuitResponse) {
        this.outputPower = this.ratingResponse().CircuitResponse.OutputPower;
        this.fullLoadAmps = this.ratingResponse().CircuitResponse.FullLoadAmps;
      }
    }
  }

  private clearOutputValues(): void {
    this.airflow = 0;
    this.outputPower = 0;
    this.fullLoadAmps = 0;
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  getAirflowMeasurementUnits(): string {
    return UnitConversionUtils.getAirflowUnits(this.isMetric);
  }

}
